import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ErrordialogComponent } from '../errordialog/errordialog.component';
import { ApiCallsService } from '../services/api-calls.service';
import { globalEnvironment } from '../constants';

@Component({
  selector: 'app-searchform',
  templateUrl: './searchform.component.html',
  styleUrls: ['./searchform.component.scss']
})
export class SearchformComponent implements OnInit {
  searchForm!: FormGroup;
  pxCodeDesc: string = "";
  isLoading: boolean = false;
  isProgressing: boolean = false;
  progressValue: number = 4;
  serviceDate: string = "";
  filteredPXDesc: any[] = [];
  pxcodeDescList: any;
  statesList: any[] = [];
  plantypeList: any[] = [];
  policyDetails: any[] = [];
  selectedState: string = "";
  selectedPlantype: string = "";
  formSubmitted: boolean = false;
  hideSearch: boolean = false;
  showPolicyTooltip: boolean = false;
  pxDescException: boolean = false;
  noDataAvailable: boolean = false;
  
  @Output() showDataTable = new EventEmitter<any>();
  @Output() searchedData = new EventEmitter<any>();
  @Output() searchFormData = new EventEmitter<any>();

  constructor(private searchFormService: ApiCallsService, private fb: FormBuilder, private snackBar: MatSnackBar, public dialog: MatDialog, private datePipe: DatePipe) { }

  getPlantypeList(): any[] {
    let isSit = globalEnvironment.environmentUrl.split(/[/.]/).includes("sit");
    if(isSit){
      return this.plantypeList;
    }
    return ['Commercial'];
  }

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      pcode: ['', [Validators.required, Validators.minLength(5)]],
      pxcodedesc: [],
      keySearch: [],
      policy: ['', [Validators.required]],
      plantype: ['', [Validators.required]],
      state: [],
      servicedate: new Date()
    });
    this.searchFormService.getStateBasedOnLob('CSBD').subscribe((data: any) => {
      this.statesList = data;
    });
    this.plantypeList = ['Medicaid', 'Commercial'];
  }

  get searchFormControl() {
    return this.searchForm.controls;
  }

  handleKeywordSearch() {
    let keySearch = this.searchForm.value['keySearch'];
    this.pxDescException = false;
    this.noDataAvailable = false;
    if(keySearch.length >= 5) {
      this.getProDetailsByKeySearch(keySearch);
    }
    if(keySearch === '') {
      this.filteredPXDesc = [];
    }
  }

  getProDetailsByKeySearch(keySearch: any) {
    this.isLoading = true;
    this.searchFormService.getProcedureDetails(keySearch).subscribe((data: any) => {
      this.filteredPXDesc = data.map((item: { pxcode: string; fullDesc: string; }) => {
        return item.pxcode + "  " + item.fullDesc;
      });
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    });
  }

  onKeyWordSearchSelect(event: MatAutocompleteSelectedEvent) {
    const optionSelected = event.option.value;
    this.searchForm.patchValue({
      pcode: optionSelected.substring(0, optionSelected.indexOf(' ')),
      pxcodedesc: optionSelected.substring(optionSelected.indexOf(' ') + 1),
      keySearch: '',
      policy: '',
    });
    this.pxCodeDesc = optionSelected.substring(optionSelected.indexOf(' ') + 1)
    if(this.searchForm.value['keySearch'] === '') {
      this.filteredPXDesc = [];
    }
    let pcode = this.searchForm.value['pcode'];
    let state = this.searchForm.value['state'];
    if(pcode.length == 5 && state != "" && this.selectedPlantype != "") {
      this.getPolicyByPxcode(state, this.selectedPlantype, pcode);
    }
  }

  onKeyChange() {
    let pcode = this.searchForm.value['pcode'].toUpperCase();
    let state = this.searchForm.value['state'];
    this.noDataAvailable = false;
    this.pxCodeDesc = "";
    this.policyDetails = [];
    this.pxDescException = false;
    this.searchForm.patchValue({
      pxcodedesc: '',
      policy: '',
    });
    if(pcode.length >= 5 && state != "" && this.selectedPlantype != "") {
      this.getPolicyByPxcode(state, this.selectedPlantype, pcode);
    }
    if(pcode.length >= 5) {
      this.getProCdDescription(pcode);
      this.showDataTable.emit(true);
    } else {
      this.showDataTable.emit(false);
    }
  }

  getPolicyByPxcode(state: string, plantype: string, pxCode: string): void {
    this.searchFormService.getPolicyNumbers(state, plantype, pxCode).subscribe((data: any) => {
      this.policyDetails = data;
      this.hideSearch = false;
    }, (error) => {
      console.log(error);
      this.policyDetails = []
      this.isLoading = false;
      this.hideSearch = true;
      this.openDialog();
    });
  }

  openDialog() {
    this.dialog.open(ErrordialogComponent);
  }

  handlePolicyNumber() {
    this.noDataAvailable = false;
    this.showDataTable.emit(false);
    this.searchForm.get('servicedate').setValue(new Date());
    this.searchForm.get('policy').setValue('');
    if(this.searchForm.value['plantype'] == "Medicaid") {
      this.selectedPlantype = "CAID";
    }
    if(this.searchForm.value['plantype'] == "Commercial") {
      this.selectedPlantype = "CSBD";
    } 
    if(this.selectedPlantype) {
      this.getStatesBasedOnPlantype(this.selectedPlantype);
    }
    if(this.selectedState && this.selectedPlantype) {
      this.getPolicyNumbers(this.selectedState, this.selectedPlantype);
    }
  }

  policySelection() {
    this.showDataTable.emit(false);
    this.noDataAvailable = false;
  }

  getPolicyNumbers(state: string, plantype: string): void {
    this.isLoading = true;
    this.searchFormService.getPolicyNumbers(state, plantype).subscribe((data: any) => {
      this.policyDetails = data;
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    });
  }

  getStatesBasedOnPlantype(plantype: string) {
    this.isLoading = true;
    this.searchFormService.getStateBasedOnLob(plantype).subscribe((data: any) => {
      this.statesList = data;
      this.searchForm.patchValue({
        pcode: '',
        pxcodedesc: '',
      });
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    });
  }

  getPlantypeBasedOnState(state: string) {
    this.isLoading = true;
    this.searchFormService.getLobBasedOnState(state).subscribe((data: any) => {
      const plantypeVal = data.map((item: { lobdescription: any }) => item.lobdescription);
      this.plantypeList = [...new Set(plantypeVal)];
      this.searchForm.patchValue({
        pcode: '',
        pxcodedesc: '',
      });
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    });
  }

  getSearchedDetails(state: string, plantype: string, proCode: any[], predCount: number) {
    let reqObj = {
      state: state,
      lob: plantype,
      procCd: proCode,
      predictionsCount: predCount,
    }
    this.isLoading = true;
    this.searchFormService.getPolicyProCdDetails(reqObj).subscribe((data: any) => {
      this.showDataTable.emit(true);
      this.searchedData.emit(data);
      this.searchFormData.emit([this.searchForm.value, this.serviceDate]);
      this.noDataAvailable = false;
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
      this.noDataAvailable = true;
    })
  }

  getSearchWithPolicyNum(state: string, plantype: string, proCode: any[], policy: string, predCount: number) {
    let reqObj = {
      state: state,
      lob: plantype,
      procCd: proCode,
      policyNumber: policy,
      predictionsCount: predCount,
    }
    this.isLoading = true;
    this.searchFormService.getPolicyProCdDetails(reqObj).subscribe((data: any) => {
      if(data.predictions.length === 0) {
        this.noDataAvailable = true;
        this.showDataTable.emit(false);
      } else {
        this.showDataTable.emit(true);
        this.searchedData.emit(data);
        this.searchFormData.emit([this.searchForm.value, this.serviceDate]);
        this.noDataAvailable = false;
      }
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
      this.noDataAvailable = true;
    })
  }

  handleSearch() {
    this.formSubmitted = true;
    let pcode = this.searchForm.value['pcode'].toUpperCase();
    let state = this.searchForm.value['state'];
    let plantype = this.searchForm.value['plantype'];
    let policy = this.searchForm.value['policy'];
    let proCode = [pcode];
    let predCount = 15;
    let tempServDate = this.searchForm.value['servicedate'];
    this.serviceDate = this.datePipe.transform(tempServDate, 'MM-dd-yyyy');

    if(predCount != null && this.policyDetails.length && state != "" && plantype != "" && policy != "" && pcode != "" && pcode != null) {
      this.getSearchWithPolicyNum(state, this.selectedPlantype, proCode, policy, predCount);
      this.searchLogsWithPolicy(state, this.selectedPlantype, this.serviceDate, pcode, policy);
    } else if(predCount != null && this.policyDetails.length && state != "" && plantype != "" && pcode != "" && pcode != null) {
      this.getSearchedDetails(state, this.selectedPlantype, proCode, predCount);
      this.searchLogsWithoutPolicy(state, this.selectedPlantype, this.serviceDate, pcode);
    }
  }

  searchLogsWithoutPolicy(state: string, plantype: string, serviceDate: string, proCode: string) {
    let reqObj = {
      state: state,
      planType: plantype,
      servicedate: serviceDate,
      procedureCode: proCode,
      status: "Success",
      sender: "UI"
    }
    this.isLoading = true;
    this.searchFormService.searchLogs(reqObj).subscribe((data: any) => {
      console.log("search log without policy>>>>>>>>>", data);
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    })
  }

  searchLogsWithPolicy(state: string, plantype: string, serviceDate: string, proCode: string, policy: string) {
    let reqObj = {
      state: state,
      planType: plantype,
      servicedate: serviceDate,
      procedureCode: proCode,
      policyNumber: policy,
      status: "Success",
      sender: "UI"
    }
    this.isLoading = true;
    this.searchFormService.searchLogs(reqObj).subscribe((data: any) => {
      console.log("search log with policy>>>>>>>>>", data);
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    })
  }

  getProCdDescription(proCd: string) {
    this.isLoading = true;
    this.searchFormService.validateProCd(proCd).subscribe((data: any) => {
      this.pxCodeDesc = data.fullDesc;
      this.searchForm.patchValue({
        pxcodedesc: this.pxCodeDesc,
        keySearch: '',
      });
      if(this.policyDetails.length !== 0) {
        this.hideSearch = false;
      }
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
      this.pxDescException = true;
    });
  }

  downloadCurrRecomendation() {
    let pcode = this.searchForm.value['pcode'].toUpperCase();
    let state = this.searchForm.value['state'];
    if(pcode != "" && pcode != null && state != "" && this.selectedPlantype != "" && pcode.length == 5 && this.policyDetails.length) {
      this.downloadCurrentToExcel(this.selectedPlantype, state, pcode);
      this.currRecomDownloadLogs(this.selectedPlantype, state, pcode);
    }
  }

  downloadCurrentToExcel(plantype: string, state: string, proCd: string) {
    let reqObj = {
      lob: plantype,
      state: state, 
      procCd: [proCd],
    }
    let planType = this.searchForm.value['plantype'];
    this.isLoading = true;
    this.searchFormService.downloadToExcel(reqObj).subscribe((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); 
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `${state}-${planType}-${proCd} recommendations.xlsx`;
      anchor.click();
      window.URL.revokeObjectURL(url);
      this.isLoading = false;
      this.downloadMsgSnackbar();
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    });
  }

  downloadStatePlanRecom() {
    let state = this.searchForm.value['state'];
    if(state != "" && this.selectedPlantype != "" && this.policyDetails.length) {
      this.downloadStatePlantypeToExcel(this.selectedPlantype, state);
      this.statePlantypeDownloadLogs(this.selectedPlantype, state);
    }
  }

  downloadStatePlantypeToExcel(plantype: string, state: string) {
    let reqObj = {
      lob: plantype,
      state: state,
    }
    let planType = this.searchForm.value['plantype'];
    this.isProgressing = true;
    setInterval(() => {
      if(this.progressValue < 96) {
        this.progressValue += 2;
      }
    }, 3000);
    this.searchFormService.downloadstatePlantypeExcel(reqObj).subscribe((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); 
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `${state}-${planType} recommendations.xlsx`;
      anchor.click();
      window.URL.revokeObjectURL(url);
      this.isProgressing = false;
      this.downloadMsgSnackbar();
    }, (error) => {
      console.log(error);
      this.isProgressing = false;
    });
  }

  statePlantypeDownloadLogs(plantype: string, state: string) {
    let reqObj = {
      lob: plantype,
      state: state,
      status: "Success",
    }
    this.isLoading = true;
    this.searchFormService.downloadLogs(reqObj).subscribe((data: any) => {
      console.log("state & lob download log>>>>>>>>>", data);
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    })
  }

  currRecomDownloadLogs(plantype: string, state: string, proCd: string) {
    let reqObj = {
      lob: plantype,
      state: state,
      pxCode: proCd,
      status: "Success",
    }
    this.isLoading = true;
    this.searchFormService.downloadLogs(reqObj).subscribe((data: any) => {
      console.log("current download log>>>>>>>>>", data);
      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    })
  }

  downloadMsgSnackbar() {
    this.snackBar.open('Download complete', '', {
      duration: 3000,
      panelClass: ['download-snackbar'],
    });
  }

  resetProCode() {
    this.formSubmitted = false;
    this.pxDescException = false;
    this.noDataAvailable = false;
    this.searchForm.reset();
    this.searchForm.patchValue({
      servicedate: new Date(),
      plantype: [''],
      state: [],
    });
    window.location.reload();
  }

}
